import { InjectionToken } from '@angular/core';
import { RuntimeProfile } from './config/enums';


/** `preview` hosts skip the display-only machinery: no push, no watchdog, no heartbeat. */
export const SIGNAGE_PROFILE = new InjectionToken<RuntimeProfile>('Signage runtime profile', {
  providedIn: 'root', factory: (): RuntimeProfile => RuntimeProfile.Display
});
